<!-- <div id="qr-error-message" class="section info-box warning"  *ngIf="!hasVideoAccess">
    <i class="material-icons icon">warning</i>
    No access to video stream! (Please make shure that the camera is working)
  </div> -->
<canvas #qrcanvas width="640" height="480"></canvas>
<!-- <div id="qr-reader-output" if.bind="hasVideoAccess">
    <span class="info-text" if.bind="qrValid">Found valid URL from QR code.</span>
    <span class="info-text" else>No valid URL found.</span>
  </div> -->